import { useEffect } from 'react';
import type { RefObject } from 'react';

/** Closes an open popup/dropdown when the user clicks or taps anywhere
 * outside the given element — native `<details>` only closes on clicking
 * its own `<summary>` again, which surprises users expecting the usual
 * "click elsewhere to close" behavior of a filter menu. `mousedown` (not
 * `click`) so the outside click is caught before an inside button's own
 * `click` handler would otherwise fire after re-opening. */
export function useClickOutside(ref: RefObject<HTMLElement | null>, onOutsideClick: () => void, enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;
    function handlePointerDown(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onOutsideClick();
      }
    }
    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, [ref, onOutsideClick, enabled]);
}
